/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Col_QtyInputs */

const vi_chot_so_col_qty = /** @type {(inputs: Chot_So_Col_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tồn`)
};

/**

* @param {Chot_So_Col_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_col_qty = /** @type {((inputs?: Chot_So_Col_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Col_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_col_qty(inputs)
});